import { FC } from 'react';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import styled from '../../../../styled';
import { useBuildingData } from '../../../../hooks/useBuildingDetails/buildingDetailsHooks';
import { useEnergyAnalysis } from '../../../../hooks/useEnergyAnalysis';
import useStore from '../../../../hooks/useStore';

import { Form } from './form';
import { userInputToSolcellerFormData } from './form/utils/dataMapper';

interface Props {}

// This is used across all steps - may be worth moving to a common folder?
export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-5);
  max-width: var(--content-width);
`;

export const Solceller: FC<Props> = () => {
  const { t } = useTranslation();
  const params = useParams();

  const { energyAnalysis } = useEnergyAnalysis(params.registrationId || '');
  const { building } = useBuildingData(energyAnalysis?.registrering?.energiObjektId);

  const store = useStore();
  const userInput = store.getState().register.userInput;
  const defaultValues = userInputToSolcellerFormData(userInput?.solcelledetaljer);
  const property = building || energyAnalysis?.registrering?.registreringEiendom;
  const geoLocationInput = property
    ? {
        kommunenummer: property.adresse.kommuneNummer,
        gardsnummer: property.gardsNummer,
        bruksnummer: property.bruksNummer,
        adressenavn: property.adresse.gateNavn,
        nummer: property.adresse.nummer,
        bokstav: property.adresse.bokstav
      }
    : undefined;

  return (
    <PageWrapper>
      <Heading level={1} data-size="lg">
        {t('register.solar.header')}
      </Heading>
      <Paragraph>{t('register.solar.description')}</Paragraph>
      <Form defaultValues={defaultValues} geoLocationInput={geoLocationInput} registrationId={params.registrationId} />
    </PageWrapper>
  );
};
